<template>
    <div
        v-if="!editable"
        class="uk-form-row"
    >
        <slot name="read_only">
            <label
                :class="{ [`uk-width-${width}`]: true }"
                class="uk-form-label"
            >
                <input
                    ref="field"
                    :id="identifier"
                    type="radio"
                    :name="name"
                    :checked="value===trueValue"
                    :disabled="true"
                    :class="{ [`uk-form-${size}`]: true }"
                />
                &nbsp;<slot></slot>
            </label>
        </slot>
    </div>
    <div
        v-else
        class="uk-form-row"
    >
        <label
            :class="{ [`uk-width-${width}`]: true }"
            class="uk-form-label"
        >
            <input
                ref="field"
                :id="identifier"
                type="radio"
                :name="name"
                :checked="value===trueValue"
                :aria-describedby="!!has_slot('hint')?`${identifier}-description`:false"
                :disabled="!editable"
                v-shortkey.once="shortkey"
                @shortkey="changed_by_key"
                @click.stop="changed"
                :class="{ [`uk-form-${size}`]: true }"
            />
            &nbsp;<slot></slot>
            <loader
                v-if="waiting"
                size="xs"
                color="gray"
                class="ml-2"
            />
        </label>
        <div
            v-if="!!error"
            :id="`${identifier}-description`"
            aria-live="assertive"
            class="uk-form-help-block uk-text-danger"
        >
            {{ error }}
        </div>
        <div
            v-else-if="has_slot('hint')"
            :id="`${identifier}-description`"
            aria-live="polite"
            class="uk-form-help-block uk-text-muted"
        >
            <slot name="hint"></slot>
        </div>
    </div>
</template>

<script>
import is_nibnut_component from "../mixins/IsNibnutComponent"

import Loader from "./Loader"

export default {
    name: "FormRadio",
    mixins: [is_nibnut_component],
    components: {
        Loader
    },
    methods: {
        changed (event) {
            this.$emit("input", event.target.checked ? this.trueValue : this.falseValue, this.name)
        },
        changed_by_key () {
            this.$emit("input", !this.value, this.name)
        }
    },
    computed: {
        has_hint () {
            return this.has_slot("hint")
        },
        waiting () {
            return this.saving
        }
    },
    props: {
        id: {
            type: String,
            validator: prop => !!prop
        },
        name: {
            type: String,
            validator: prop => !!prop,
            required: true
        },
        value: {
            default: false
        },
        trueValue: {
            default: true
        },
        falseValue: {
            default: false
        },
        width: {
            type: String,
            default: "1-1"
        },
        size: {
            type: String,
            validator: prop => !!prop && !!prop.match(/^(small|normal|large)$/i),
            default: "normal"
        },
        shortkey: {
            default: null
        },
        editable: {
            type: Boolean,
            default: true
        },
        saving: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ""
        }
    }
}
</script>
